module.exports = __webpack_public_path__ + "static/media/best-app-development-tool.70f40b0f.md";